<script setup lang="ts">
import type { WikiVehicle } from "~~/types/gamedata";

const props = defineProps({
  raw: {
    type: Object as () => WikiVehicle | null,
    required: true,
  },
  shipId: {
    type: String,
    required: true,
  },
});

// Bewusst awaited (anders als `useShipRating()` in der "Bewertung"-Tab, deren
// Inhalt erst nach Klick auf den bereits sichtbaren Tab gebraucht wird): hier
// entscheidet das Ergebnis, ob der "Commercial"-Tab überhaupt in der Leiste
// auftaucht — ohne Await würde er nach der Hydration sichtbar nachspringen.
const { data: commercial } = await useShipCommercial(() => props.shipId);

const tabItems = computed(() => [
  ...(props.raw?.is_spaceship || props.raw?.is_gravlev ? [{ label: 'Performance', slot: 'performance' }] : []),
  { label: 'Bewertung', slot: 'rating' },
  ...(commercial.value ? [{ label: 'Commercial', slot: 'commercial' }] : []),
]);
</script>

<template>
  <UCard variant="outline" class="bg-bunker-950 ring-0 border border-default" :ui="{ body: 'py-2 sm:py-2 sm:px-0 px-0' }">
    <template #default>
      <div>
        <UTabs
          color="outline"
          :items="tabItems"
          :ui="{ root: 'mx-2 items-stretch' }"
        >
          <template #performance>
            <ShipexkursShipHeroMainTabsPerformanceShips v-if="raw?.is_spaceship || raw?.is_gravlev" :raw="raw" />
            <ShipexkursShipHeroMainTabsPerformanceGround v-else-if="raw?.is_vehicle" :raw="raw" />
          </template>
          <template #commercial>
            <ShipexkursShipHeroMainTabsCommercial v-if="commercial" :file="commercial" />
          </template>
          <template #rating>
            <ShipexkursShipHeroMainTabsRating :ship-id="shipId" />
          </template>
        </UTabs>
      </div>
    </template>
  </UCard>
</template>
